import { advancedFiltering, type KlevuFetchModifer } from "@klevu/core";

/**
 * Klevu attribute set to "1" on records that must stay out of the regular
 * catalog and search listings (PKNEW-1510).
 *
 * The M2 export writes a box that closes at more than one height as several
 * Klevu records sharing one SKU: the normal record plus an extra `<id>-bfv`
 * copy per additional height, each with its own `bf_dim_*` / `bf_volume`. Only
 * the copies carry this attribute — the normal record has no value at all — so
 * listings have to exclude the flagged records rather than include unflagged
 * ones. The box finder builds its own query and keeps every copy.
 */
export const LISTING_HIDDEN_ATTRIBUTE = "bf_exclude_from_listing";

/** Condition dropping the listing-hidden records, as `advancedFiltering` takes it. */
export const LISTING_HIDDEN_CONDITIONS: Parameters<
  typeof advancedFiltering
>[0] = [
  {
    key: LISTING_HIDDEN_ATTRIBUTE,
    valueOperator: "EXCLUDE",
    singleSelect: false,
    values: ["1"],
  },
];

/**
 * Keeps the box finder's per-height copies out of a catalog/search query.
 *
 * Filtering in Klevu (not on the mapped records) keeps totals, facet counts and
 * pagination correct. `advancedFiltering` overwrites the query's single
 * `groupCondition`, so this can't be combined with another advanced filter on
 * the same query.
 */
export function excludeListingHiddenRecords(): KlevuFetchModifer {
  return advancedFiltering(LISTING_HIDDEN_CONDITIONS, "ALL_OF");
}
